import { Divider, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { useEffect } from "react";
import { matchPath, useLocation, useSearchParams } from "react-router";
import { Paths } from "src/constants";
import { BlockLink, DrawerLayout, useDrawer } from "../../../../components";
import { useGetPlanHistory } from "../../../../http";

interface IProps {
  planGuid: string;
  planLastModified: string | undefined;
}

const PlanVersionsDrawerContent = (props: IProps) => {
  const { data, isLoading } = useGetPlanHistory(props.planGuid, new Date().getTimezoneOffset());
  const [queryParams] = useSearchParams();
  const { closeDrawer } = useDrawer();
  const theme = useTheme();
  const location = useLocation();
  const localTimezoneOffset = new Date().getTimezoneOffset();
  const dateQueryParam = queryParams.get("date");

  useEffect(() => {
    if (!matchPath(Paths.TeamStrategicMap, location.pathname)) {
      closeDrawer();
    }
  }, [closeDrawer, location.pathname]);

  return (
    <DrawerLayout title={<Typography variant="h6">Version History</Typography>}>
      <Stack sx={{ overflow: "auto" }} divider={<Divider variant="dashed" sx={{ mx: 1 }} />}>
        {isLoading && <Skeleton />}
        {!isLoading &&
          props.planLastModified &&
          data !== undefined &&
          data.versions.map((version, index) => {
            const formattedDate = DateTime.fromISO(version.date).toFormat("yyyy-MM-dd");

            return (
              <BlockLink
                key={index}
                href={
                  index === 0
                    ? `${location.pathname}`
                    : `${location.pathname}?date=${formattedDate}&offset=${localTimezoneOffset}`
                }
                backgroundColorOnHover={theme.palette.primary.transparent5}
                sx={{ px: 1 }}
              >
                <Stack direction="row" sx={{ py: 0.5, alignItems: "center", justifyContent: "space-between" }}>
                  <Typography
                    sx={{
                      fontWeight:
                        formattedDate === dateQueryParam || (dateQueryParam == null && index === 0)
                          ? "bold"
                          : undefined,
                    }}
                  >
                    {DateTime.fromISO(version.date).toLocaleString(DateTime.DATE_FULL)}
                  </Typography>
                </Stack>
              </BlockLink>
            );
          })}
      </Stack>
    </DrawerLayout>
  );
};

export { PlanVersionsDrawerContent };
